import React, { Component } from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";


export default class SubscriberGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onRowDoubleClicked = this.onRowDoubleClicked.bind(this);

    this.columnDefs = [
      {headerName: "Company", field: "company", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 150},
      {headerName: "Name", field: "name", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 250},
      {headerName: "Position", field: "position", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 150},
      {headerName: "Email", field: "email", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 250},
      {headerName: "Phone", field: "phone", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 200},
      {headerName: "Notifications", field: "documents", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 300, wrapText: true, autoHeight: true, cellRenderer: function(params) {return params.value.join("<br/>")}},
      {headerName: "Blocks", field: "ranches", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 300, wrapText: true, autoHeight: true, cellRenderer: function(params) {return params.value.join(", ")}},
      {headerName: "Comments", field: "comments", sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 300, wrapText: true, autoHeight: true}


        
    ];
    
  }

  onSelectionChanged() {
    console.log("Changing selected row")
    var selectedNodes = this.gridApi.getSelectedNodes();
    var rowData = selectedNodes[0].data;
    //var rowNode = selectedNodes[0];
    console.info(rowData);
    this.props.onSubscriberRowSelectChange(rowData); 
  }

  onRowDoubleClicked(row){
    console.group("On Row Double Clicked Row: ");
    console.log(row.data);
    console.groupEnd();
    var rowData = row.data;
    this.props.onSubscriberRowSelectChange(rowData);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  render() {
    const divStyle = {
      width: "100%",
      height: "calc(85vh)",
      // maxWidth: "99vw",

      //border: '5px solid black'
    };

    const gridOptions = {
      onRowDoubleClicked: this.onRowDoubleClicked,
    }

    /*
    if (this.dataReady){
      console.log(" Lines (this.props.rowData) about to be rendered: ");
      console.log(this.props.rowData);
      this.gridApi.setRowData(this.props.rowData);
    }
    */

    return (
      <div className="ag-theme-balham" style={divStyle}>
        <AgGridReact
          rowSelection="single"
          enableRangeSelection={true}
          pagination={true}
          columnDefs={this.columnDefs}
          rowData={this.props.rowData}
          animateRows={true}
          onGridReady={this.onGridReady}
          onSelectionChanged={this.onSelectionChanged.bind(this)}
          gridOptions = {gridOptions}
          onRowDoubleClicked = {this.props.onEditSubscriberRequest}
          // domLayout ={'autoheight'}
          alwaysShowVerticalScroll = {true}
          alwaysShowHorizontalScroll = {true}
        />
      </div>
    );
  }
}
